import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql } = useAppContext();

  // eslint-disable-next-line import/prefer-default-export
  const PhoneNumberFragment = gql`
fragment PhoneNumberFragment on PhoneNumber {
  phoneNo
  phoneType
  ext
  isBest
}
`;

  return {
    PhoneNumberFragment,
  };
};
